export const DD_ENABLED = process.env.GATSBY_DD_ENABLED === "true";
export const RUM_ID_MAP = {
  shopmando: {
    applicationId: process.env.GATSBY_DD_APPLICATION_ID_SHOPMANDO,
    clientToken: process.env.GATSBY_DD_CLIENT_TOKEN_SHOPMANDO,
    sessionSampleRate: parseInt(
      process.env.GATSBY_DD_SAMPLE_RATE_SHOPMANDO ?? "100",
      10
    ),
    sessionReplaySampleRate: parseInt(
      process.env.GATSBY_DD_SAMPLE_REPLAY_RATE_SHOPMANDO ?? "5",
      10
    ),
  },
  lumedeodorant: {
    applicationId: process.env.GATSBY_DD_APPLICATION_ID_LUMEDEODORANT,
    clientToken: process.env.GATSBY_DD_CLIENT_TOKEN_LUMEDEODORANT,
    sessionSampleRate: parseInt(
      process.env.GATSBY_DD_SAMPLE_RATE_LUMEDEODORANT ?? "100",
      10
    ),
    sessionReplaySampleRate: parseInt(
      process.env.GATSBY_DD_SAMPLE_REPLAY_RATE_LUMEDEODORANT ?? "9",
      10
    ), // Percentage relative to sessionSampleRate, which is now always 100
  },
};
